export const sanitiseInput = (input: string) => {
  if (typeof input !== 'string') return '';

  return input
    .trim()
    .replace(/[<>'"`;()\\/]/g, '') // Remove SQL/XSS characters
    .replace(/--/g, '') // Remove SQL comments
    .replace(/\s+/g, ' ') // Normalise spaces
    .slice(0, 100);
};

export const sanitiseNameInput = (input: string): string => {
  if (typeof input !== 'string') return '';

  return input.trim().replace(/\s+/g, ' ');
};

export const sanitiseTextInput = (input: string): string => {
  if (typeof input !== 'string') return '';
  return (
    input
      // eslint-disable-next-line no-control-regex
      .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '')
      .trim()
  );
};

/** Live "used/max" helper text, e.g. for a Biography field capped at 2500 characters. */
export const getCharacterCountHelperText = (
  value: string | null | undefined,
  max: number,
): string => {
  const length = value?.length ?? 0;

  return length >= max
    ? `Character limit reached (${max} max).`
    : `${length}/${max} characters`;
};

export const hasReachedCharacterLimit = (
  value: string | null | undefined,
  max: number,
): boolean => (value?.length ?? 0) >= max;

/**
 * Sanitise display name - remove dangerous characters but keep spaces, hyphens, apostrophes
 */
export const sanitiseDisplayName = (input: string): string => {
  if (typeof input !== 'string') return '';

  return input
    .trim()
    .replace(/[<>'"`;()\\]/g, '')
    .replace(/\s+/g, ' ')
    .slice(0, 100);
};

/**
 * Sanitise email - basic cleanup, let backend validate format
 */
export const sanitiseEmail = (input: string): string => {
  if (typeof input !== 'string') return '';

  return input.trim().toLowerCase().slice(0, 254); // Max email length per RFC
};
